const handleGoTop = () => {
  const btnSelector = '.go-top-btn';

  const btnEl = document.querySelector(btnSelector);

  btnEl?.addEventListener('click', () => {
    document.body.scrollIntoView({
      block: 'start',
      inline: 'start',
      behavior: 'smooth',
    });
  });
};

export default handleGoTop;
